// import React, {Component} from "react";
import { Tab, TabPanel, Tabs, TabList } from "react-web-tabs";
// import ReactDOM from "react-dom";
import config from 'react-global-configuration';
import "react-web-tabs/dist/react-web-tabs.css";
import React, {Component, useState} from 'react';
import axios from "axios";
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import AsyncPaginate, {reduceGroupedOptions} from 'react-select-async-paginate';
import moment from 'moment';
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {List} from "react-virtualized";


const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;


class AdminViewPromotion extends Component {

    downloadSchemeMasterAsCSV = () => {
  const data = this.state.scheme_master_data;
  if (!data || data.length === 0) {
    alert("No scheme data available to export");
    return;
  }

  const headers = Object.keys(data[0]);

  const csvRows = [
    headers.join(','), // CSV header
    ...data.map(row =>
      headers.map(field => {
        const value = row[field];
        if (typeof value === 'string') {
          // Escape double quotes and wrap strings that contain commas
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',')
    )
  ];

  const csvContent = csvRows.join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "scheme_master_data.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


    constructor(props) {
        super(props);
        this.state = {
            activer: [],
            isEMI: [],
            isUpfront: [],
            zeroCost: [],
            _notificationSystem: null,
            mapField: false,
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            brand_subvention_list:{},
            bank_subvention_list: [],
            brand_subvention_value: {},
            bank_subvention_value: [],
            maximum_cashback: [],
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            endDateExtend: null,
            startDateExtend: null,
            sku_showModel: false,



            selceted_emi_type_value_label: [{value: '', label: ''}],
            selected_emi_type_option: [
                {value: 'ALL', label: 'ALL'},
                {value: 'Unipaynext', label: 'Unipaynext'},
                {value: 'TotalEMI', label: 'TotalEMI'},
                {value: 'TrueEMI', label: 'TrueEMI'},
            ],



            sku_list: [],
            raw_display_data: [],
            promotion_file_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            brand_has_merchant: [],
            stepper: [false, true, true, true],
            current_tab: 'vertical-tab-one',
            campaign_name: '',
            campaign_desc: '',
            merchant_length: null,
            merchant_counter: 1,
            merchant_counter_array: [0],
            follower: false,
            scheme_id: 0,
            scheme_display_data: [],
            sku_display_data: [],
            campaign_display_data: [],
            scheme_active: 0,
            mapFieldCampaign: false,
            mapFieldConfigure: false,
            mapFieldExtendMerchants: false,
            mapFieldQA: false,
            mapFieldExtend: false,
            mapFieldFinal: false,
            campaignConfirmationModel: false,
            campaignConfigureModel: false,
            campaignQAModel: false,
            campaignExtendModel: false,
            campaignFinalModel: false,
            campaignExtendMerchantsModel: false,
            campaignID: null,
            brand_user_id: 13,
            scheme_master_data: [],
            scheme_master_list: [],
            newConfirmationModel: false,
            merchant_master_data: [],
            activer7: [],
            merchant2_display_data: [],
            merchant_master_list: [],
            party_id_mapper: [],
            party_master_id: null,
            reason: '',
            campaignDeconfirmationModel: false,
            emiMenus:[],
            merchantList:[],
            chainList:[],
            utidList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            utidID:'',
            merchantValue:[],
            chainValue:[],
            storeList:[],
            storeValue: [],
            utidValue:[],
            upload_it: false,
            selectedFile: null,
            merchant_table_master_data: null,
            //redirect = false,
            scheme_sku_mapper_data: [],
            automation_type: 'new',
            automation_type_value: {value: 'new', label: 'New Automation'},
            instance_type: '1',
            instance_type_value: {value: '1', label:'RELI0001 192.168.0.26:5454'},
            promotion_flag: 0,
            ip_instance_data: [],
            utidValueExtend: [],
            extend_button: false,
            canChangePromotionStatus: false,
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount(){
        // await this.getPartyID();
        const canChangePromotionStatus = this.canChangePromotionStatus();
        this.setState({
            canChangePromotionStatus: canChangePromotionStatus
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this._getCampaignData();
        this._getAllMerchants();
        //this._getAllMerchantsTable();
        this._refreshSku_Show_View_Promotion();
        this.getSchemeMasterDataView();
        this.getSchemeSkuMapperTable();
        //this._getAllUtid();
        //this.getIpInstanceData();
        this.setState({
            campaignID: this.props.match.params.id,
            user_id: decoded._id,
            _notificationSystem: this.refs.notificationSystem
        })
        // , () =>{
        //     this._refreshPromotionFiles();
        // }
        // await this._findBrandUserID();
        // await this._refreshSku_Show_View();
        // //await this.brand_has_merchant_finder();
        // await this._getSchemeData();
        // await this._getSkuData();
        // await this._getCampaignData();
        // await this._getMerchantFileUploaded();
        // await this._getSchemeMappingUploaded();
        // await this._getSchemeDetails();
        // await this.getSchemeMasterDataView();
        // //await this.getMerchantMasterDataView();
        // await this._getMerchantDetails();


        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }

    campaignDropdown = () => {
        if(!this.state.canChangePromotionStatus) {
            this.handleNotificationClick("tr", 3, "You don't have permission to change promotion status");
            return;
        }
        this.props.history.push('/admin/admin-create-promotion1');
    }
    // get details of campaign/promotion metadata, get id so that we can get selected products, schemes and merchants of that campaign/promotion
    _getAllMerchants(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {

                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    canChangePromotionStatus = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log("Decoded user ID:", decoded._id);

        // List of user IDs who can change promotion status
        const allowedUsers = process.env.REACT_APP_ALLOWED_USER;
        const allowedMotUsers = process.env.REACT_APP_ALLOWED_MOT_TEAM;
        console.log("Allowed users canChangePromotionStatus:", allowedUsers);
        console.log("Allowed MOT users canChangePromotionStatus:", allowedMotUsers);
        return allowedUsers.includes(decoded._id) || allowedMotUsers.includes(decoded._id);
    }

    _getAllMerchants1(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {

                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
            this.getMerchantData();
        });
    }

    changeMerchant1(optionSelected){
        //console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        }, () =>{
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    }

    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            //console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }

    getChain1(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            //console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });
            this.setState({
                chainList:chalinList
            }, () =>{
                this.getChainData();
                //this.
            })
        });
    }

    changeChain(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

        this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);


    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            //console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }


    getStore1(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            //console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            }, () =>{
                this.getStoreData();
            })
        });
    }

    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
        this.getUtid(sidArray, 'store', this.state.object_type, this.state.storeID);
    }

    getUtid(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-utid', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                mid: '',
                cid: '',
                sid: code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let utidListExtend = [];
            this.setState({utidIDExtend:''});
            console.log(response.data);
            response.data.map((utid,index) => {
                utidListExtend.push({value: utid.utid, label: utid.utid, value1:utid.merchant_code, value2: utid.chain_code, value3: utid.store_code, chain_name: utid.chain_name, merch_name: utid.merchant_name, store_name: utid.store_name})
            });
            this.setState({
                utidListExtend: utidListExtend
            })
        });
    }

    getMerchantData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-merchant',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                let value='';
                let midArray = [];
                let optionSelected = [];
                response.data.map((mids, i) => {
                    midArray.push(mids.merchant_code)
                    var index = this.state.merchantList.findIndex(obj => obj.value==mids.merchant_code);
                    this.state.merchantList.move(index,0).join(',');
                    optionSelected.push({value: mids.merchant_code, label: mids.merchant_name})
                });
                //console.log(midArray);
                //console.log(optionSelected);
                this.setState({
                    merchantID:midArray,
                    chainID:'',
                    merchantValue:optionSelected,
                    chainValue:[],
                    storeID:'',
                    storeValue: []
                }, () =>{
                    this.getChain1(midArray, 'merchant', this.state.object_type, this.state.object_code);
                    this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
                    // response.data.map((merchant, index) => {
                    //     this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                    // });
                });
            }
        });
    }

    getChainData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-chain',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                let cidArray = [];
                let optionSelected = [];
                if(response.data[0]['chain_code'] == 9){
                    //console.log("Yay");
                }
                else{
                    response.data.map((cids, i) => {
                        cidArray.push(cids.chain_code)
                        var index = this.state.chainList.findIndex(obj => obj.value==cids.chain_code);
                        this.state.chainList.move(index,0).join(',');
                        optionSelected.push({value: cids.chain_code, label: cids.chain_name, value1: cids.merchant_code, merch_name: cids.merchant_name })
                    });
                    this.setState({
                        chainID: cidArray,
                        chainValue:optionSelected,
                        storeID:'',
                        storeValue: []
                    }, () => {
                        this.getStore1(cidArray, 'chain', this.state.object_type, this.state.merchantID);
                    });
                }
            }
        });
    }

    getStoreData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-store',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                let value='';
                let sidArray = [];
                let optionSelected = [];
                //console.log(response.data);
                if(response.data[0]['store_code'] == 9){
                    //console.log("Yay");
                }
                else{
                    response.data.map((sids, i) => {
                        sidArray.push(sids.store_code)
                        var index = this.state.storeList.findIndex(obj => obj.value==sids.store_code);
                        this.state.storeList.move(index,0).join(',');
                        optionSelected.push({value: sids.store_code, label: sids.store_name, value1: sids.merchant_code, value2: sids.chain_code, merch_name: sids.merchant_name, chain_name: sids.chain_name});
                    });

                    this.setState({
                        storeID: sidArray,
                        storeValue:optionSelected
                    });
                }
            }
        });
    }

    _getAllUtid(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-utid',{
            promotion_id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length) {
                response.data.data.map((utid, index) => {
                    //console.log(utid);
                    this.state.utidList.push({value: utid.utid, label: utid.utid, value1: utid.merchant_code, value2: utid.store_code})
                });
            }
        });
    }

    _getAllUtidExtend(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-utid-extend',{
            promotion_id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length) {
                response.data.data.map((utid, index) => {
                    //console.log(utid);
                    this.state.utidListExtend.push({value: utid.utid, label: utid.utid, value1: utid.merchant_code, value2: utid.chain_code, value3: utid.store_code})
                });
            }
        });
    }

    changeUtid(optionSelected){
        //console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.utidList.findIndex(obj => obj.value==mids.value);
                this.state.utidList.move(index,0).join(',');
            });
        }
        this.setState({
            utidID:midArray,
            utidValue:optionSelected
        });
    }

    changeUtidExtend(optionSelected){
        //console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.utidListExtend.findIndex(obj => obj.value==mids.value);
                this.state.utidListExtend.move(index,0).join(',');
            });
        }
        this.setState({
            utidIDExtend:midArray,
            utidValueExtend:optionSelected
        });
    }

    changeAutomationType = (valuer) => {
        this.setState({
            automation_type: valuer.value,
            automation_type_value: {value: valuer.value, label: valuer.label}
        });
    };

    changeInstanceType = (valuer) => {
        this.setState({
            instance_type: valuer.value,
            instance_type_value: {value: valuer.value, label: valuer.label}
        });
    };


    _getCampaignData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            ////console.log(response.data);
            console.log(response);
            const values = response.data;
            // ✅ Specifically check this field
            console.log("promotionStartDate:", values.promotionStartDate);

            this.setState({
            party_master_id: values.manufacturerCode,
            campaign_name: values.promotionName,
            campaign_desc: values.promotionDescription,
            //startDate: values.promotionStartDate,
            startDate: moment(values.promotionStartDate).format('YYYY-MM-DD'),
            //endDate: values.promotionEndDate,
            endDate: new Date(new Date(values.promotionEndDate).getTime() + 86400000).toISOString().split("T")[0],
            endDateExtend: values.promotionEndDate,
            startDateExtend: new Date(values.promotionStartDate),
            scheme_active: values.state,
            promotion_flag: values.flag,
            reason: values.recordUpdateReason,
            brand_user_id: values.recordUpdateUser,
            selceted_emi_type_value_label: [{
                value: values.innovitiProducts,
                label: values.innovitiProducts
            }]
            }, () => {
                this.getMerchantMappingData();
                // this._findBrandUserID();
            });

            this.setState({
            campaign_display_data: response.data
            });
        });
    }

    //get the list of schemes uploaded by user
    getSchemeMasterDataView(){
        if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
            $('#brandSchemeMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/view_brand_schemes_promotion1',
            {
                promotion_id: this.props.match.params.id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                    if (response.status === 200 && Array.isArray(response.data)) {
                        const cleanField = (field) => {
                        if (!field) return '';
                        return String(field).replace(/[\r\n]+/g, ' ').trim();
                    };
                    const scheme_master_data_export = response.data.map(item => ({
                    "Scheme Type": item.schemeType || '',
                    "Is_Zero_Cost": item.emiType || '',
                    "Additional Cashback?": item.availCashback || '',
                    "scheme_name": item.schemeName || '',
                    "bank_name": item.bankName || '',
                    "Tenure": item.tenure || '',
                    "Upfront Promotion Type": item.upfrontBrandSub == 'NA'?'NA':'Instant', // assuming static, adjust if dynamic
                    "Upfront Discount Type": item.upfrontBrandSub || '',    // assuming static, adjust if dynamic
                    "Upfront Discount Worth": item.upfrontBrandSubAmount?.replace(/PU$/, '') || '',
                    "Upfront Maximum Cashback": item.upfrontMaxCashback?.replace(/F$/, '') || '',
                    "Post Promotion Type": item.postBrandSub == 'NA'?'NA':'Post',    // assuming static
                    "Post Discount Type": item.postBrandSub || '',        // assuming static
                    "Post Discount Worth": item.postBrandSubAmount || '',
                    "Post Maximum Cashback": item.postBrandMaxAmount || '',
                    "TID": item.tid || '',
                    "Low Cost Subvention": item.lowCostSubvention || '',
                    "Brand Zero Cost EMI Subvention(%)": item.zceCashbackBrand || '',
                    "Bank Zero Cost EMI Subvention(%)": item.zceCashbackBank || '',
                    "Merchant Zero Cost EMI Subvention(%)": item.zceCashbackMerchant || '',
                    "Innoviti Zero Cost EMI Subvention(%)": item.zceCashbackInnoviti || '',
                    "Customer Zero Cost EMI Subvention(%)": item.zceCashbackCustomer || '',
                    "Upfront Brand Cashback Subvention(%)": item.upfrontCashbackBrand || '',
                    "Upfront Bank Cashback Subvention(%)": item.upfrontCashbackBank || '',
                    "Upfront Merchant Cashback Subvention(%)": item.upfrontCashbackMerchant || '',
                    "Upfront Innoviti Cashback Subvention(%)": item.upfrontCashbackInnoviti || '',
                    "Upfront Customer Cashback Subvention(%)": item.upfrontCashbackCustomer || '',
                    "Post Brand Cashback Subvention(%)": item.postCashbackBrand || '',
                    "Post Bank Cashback Subvention(%)": item.postCashbackBank || '',
                    "Post Merchant Cashback Subvention(%)": item.postCashbackMerchant || '',
                    "Post Innoviti Cashback Subvention(%)": item.postCashbackInnoviti || '',
                    "Post Customer Cashback Subvention(%)": item.postCashbackCustomer || '',
                    "Bank Per CashBack": item.bankCbPer || '',
                    "Bank Max CashBack": item.bankMaxCb || '',
                    //"Charge Slip Additional Contains": item.additonalContains || '',
                    "Charge Slip Additional Contains": cleanField(item.additonalContains), 
                    "Additional T&C": item.additionalTermsConditions || ''
                }));

                    this.setState({
                        scheme_master_data: response.data,
                        scheme_master_data_export: scheme_master_data_export
                    });
                    $('#brandSchemeMasterViewTable').DataTable();
                } else {
                    console.error('Unexpected response:', response);
                    this.setState({ loading: false });
                }
            }
        );
        return null
    }

    getIpInstanceData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/get_ip_instance_data',
            {
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data.data) && response.data.data.length) {
                response.data.data.map((values, index) => {
                    this.state.ip_instance_data.push({value: values.id, label: values.merchant_code + " " + values.ip + ":" + values.port})
                });
            }
        });
        return null
    }

    _getAllMerchantsTable(){
        if ($.fn.DataTable.isDataTable('#brandMerchantMasterViewTable')) {
            $('#brandMerchantMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/download_promotion_merchant_details_table',
            {
                promotion_id: this.props.match.params.id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                merchant_master_data: response.data.data
            });
            $('#brandMerchantMasterViewTable').DataTable();
        });
        return null
    }

    getSchemeSkuMapperTable(){
        if ($.fn.DataTable.isDataTable('#schemeSKUMapperViewTable')) {
            $('#schemeSKUMapperViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/scheme_sku_mapping_details',
            {
                promotion_id: this.props.match.params.id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => { console.log(response.data)
            this.setState({
                scheme_sku_mapper_data: response.data
            });
            $('#schemeSKUMapperViewTable').DataTable();
        });
        return null
    }



    //get partyID of user
    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroup == 1 || decoded.userGroup == '1'){
            this.setState({
                party_master_id: 3,
                loading: false,
                user_id: decoded._id
            });
        }
        else{
            axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    user_id: decoded._id,
                }
            }).then(response => {
                //console.log(response.data);
                this.setState({
                    party_id_mapper: response.data
                });
                $('#party_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }
    }

    //get merchants configured in backend
    getMerchantMappingData(){
        if(this.state.party_master_id != null){
            if ($.fn.DataTable.isDataTable('#merchant_showTable')) {
                $('#merchant_showTable').DataTable().destroy();
            }
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    party_master_id: this.state.party_master_id
                }
            }).then(response => {
                //console.log(response.data);
                this.setState({
                    merchant2_display_data: response.data
                });
                $('#merchant_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }
    }

    // get selected schemes for that campaign
    // _getSchemeDetails(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_scheme_details',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             id: this.props.match.params.id,
    //         }
    //     }).then(response => {
    //         ////console.log(response.data);
    //         //console.log(response);
    //         response.data.map((values, index) => {
    //             this.setState({
    //                 scheme_master_list: {...this.state.scheme_master_list, [values.scheme_id]: true}
    //             })
    //         })
    //         //console.log("DOne");
    //     });
    // }

    //get selected merchants for the campaign
    _getMerchantDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_details',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            ////console.log(response.data);
            //console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    merchant_master_list: {...this.state.merchant_master_list, [values.merchant_data_id]: true}
                })
            })
            //console.log("DOne");
        });
    }

    //get selected products of campaign/promotion
    // _getSkuData(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_scheme_sku_data',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             campaignID: this.props.match.params.id,
    //         }
    //     }).then(response => {
    //         //console.log(response);
    //         response.data.map((values, index) => {
    //             this.setState({
    //                 sku_list: {...this.state.sku_list, [values.sku]:true}
    //             })
    //         })
    //         this.setState({
    //             sku_display_data: response.data
    //         });
    //         //console.log("DOne");
    //     });
    // }

    //get the user_id of the brand whcih uploaded the data
    _findBrandUserID(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_user_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            ////console.log(response.data);
            //console.log(response);
            response.data.map((values, index) => {
                //console.log(values.user_id);
                this.setState({
                    brand_user_id: values.user_id
                })
            })
            //console.log("DOne");
        });
    }

    //get list of all possible products for brand
    _refreshSku_Show_View_Promotion() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        //console.log(this.state.brand_user_id);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/view_brand_sku2',
            {
                promotion_id: this.props.match.params.id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if (response.status === 200 && Array.isArray(response.data)) {
                    this.setState({
                        raw_display_data: response.data
                    });
                    $('#sku_showTable').DataTable();
                } else {
                    console.error('Unexpected response:', response);
                    this.setState({ loading: false });
                }
            }
        );
    }

    // _refreshPromotionFiles() {
    //     if ($.fn.DataTable.isDataTable('#promotion_files')) {
    //         $('#promotion_files').DataTable().destroy();
    //     }
    //     //console.log(this.state.brand_user_id);
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/view_promotion_files',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             promotion_id: this.state.campaignID,
    //         }
    //     }).then(response => {
    //         //console.log(response.data);
    //         this.setState({
    //             promotion_file_display_data: response.data
    //         });
    //         $('#promotion_files').DataTable();
    //     });
    // }


    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleExtendChange = date => {
        this.setState({
            endDateExtend: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleExtendStartDateChange = date => {
        this.setState({
            startDateExtend: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    changeSKU = (sku, checked) => {
        let sku_monitor_incr = this.state.sku_monitor;
        if (checked === true){
            this.setState((state) => ({
                sku_monitor: state.sku_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                sku_monitor: state.sku_monitor - 1
            }))
        }
        this.setState({
            sku_list: {...this.state.sku_list, [sku]:checked},
            mapField2: false,
            mapField: false
        });
    };

    skuMapping() {
        ////console.log("hello world");
    }

    toggleConfirmationModel() {
        //if (this.state.sku_list.length == 0){
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }
    }

    toggleCampaignModel() {
        this.setState({
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    toggleConfigureModel() {
        this.setState({
            campaignConfigureModel: !this.state.campaignConfigureModel
        });
    }

    toggleQAModel() {
        this.setState({
            campaignQAModel: !this.state.campaignQAModel
        });
    }

    toggleExtendModel() {
        this.setState({
            campaignExtendModel: !this.state.campaignExtendModel
        });
    }

    toggleExtendMerchantModel() {
        this.setState({
            campaignExtendMerchantsModel: !this.state.campaignExtendMerchantsModel
        });
    }

    toggleFinalModel() {
        this.setState({
            campaignFinalModel: !this.state.campaignFinalModel
        });
    }


    toggleDecampaignModel() {
        this.setState({
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };


    updateMapVisiblity = (value) => {
        ////console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, [index]:checked.target.checked },
            mapField: false

        });
    }

     showUnauthorizedPopup = (actionName) => {
        this.handleNotificationClick("tr", 3, `You are not authorized to perform "${actionName}". Please contact your administrator.`);
    }


    //activate campaign action is sent to backend
    sendConfigureCampaign = () => {
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("configure this promotion");
            return;
        }
        var data = {
            scheme_id: this.state.campaignID
        }
        axios.post(config.get('API_URL') + '/brandemi/submit_campaign_configure', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            setTimeout(function(){
                this.componentDidMount()
            }.bind(this), 200);
            this.props.history.push('/admin/admin-promotion-master')
        }).catch(err => {

        })

    }

    sendQAVerifiedCampaign = () => {
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("Verify this promotion");
            return;
        }

        var data = {
            promotion_id: this.state.campaignID,
            utids: this.state.utidValueExtend.join(','),
            user_id: this.state.user_id
        }
        axios.post(config.get('API_URL') + '/brandemi/submit_qa_activate', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {

            setTimeout(function(){
                this.componentDidMount()
            }.bind(this), 200);
            this.props.history.push('/admin/admin-promotion-master')
        }).catch(err => {

        })

    }

    sendFinalCampaign = () => {
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("approve this promotion");
            return;
        }

        var data = {
            scheme_id:  this.state.campaignID,
            automation_type: this.state.automation_type,
            instance_type: this.state.instance_type
        }
        axios.post(config.get('API_URL') + '/brandemi/submit_final_activate_new', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {

            setTimeout(function(){
                this.componentDidMount()
            }.bind(this), 200);
            this.props.history.push('/admin/admin-promotion-master')
        }).catch(err => {

        })

    }

    sendExtendPromotion = () => {
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("extend this promotion");
            return;
        }
        this.setState({
            extend_button: true
        })

        // Validate both dates exist
        if (!this.state.startDateExtend) {
            this.handleNotificationClick("tr", 3, "Please select a new start date");
            this.setState({ extend_button: false });
            return;
        }
    
        if (!this.state.endDateExtend) {
            this.handleNotificationClick("tr", 3, "Please select a new end date");
            this.setState({ extend_button: false });
            return;
        }
    
        // ADD THIS VALIDATION - Check start date is before end date
        const startDate = new Date(this.state.startDateExtend);
        const endDate = new Date(this.state.endDateExtend);
    
        if (startDate > endDate) {
            this.handleNotificationClick("tr", 3, "New start date must be before new end date");
            this.setState({ extend_button: false });
            return;
        }
    
        // Optional: Also validate that new start date is not before current date
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        if (startDate < today) {
            this.handleNotificationClick("tr", 3, "New start date cannot be in the past");
            this.setState({ extend_button: false });
            return;
        }

        var data = {
            promotion_id: this.state.campaignID,
            promotion_name: this.state.campaign_name,
            user_id: this.state.user_id,
            // old_end_date: this.state.endDate,
            new_end_date: this.state.endDateExtend,
            new_start_date: this.state.startDateExtend 
        }
        axios.post(config.get('API_URL') + '/brandemi/submit_extend_promotion', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            if(res.data.flag == '0'){
                this.handleNotificationClick("tr", 1, "Promotion successfully extended");

                // Close popup modal
                this.setState({ campaignExtendModel: false });

                setTimeout(() => {
                window.location.href = '/admin/admin-promotion-master'; // ⬅ reloads the page
                }, 2000);

                setTimeout(function(){this.props.history.push('/admin/admin-promotion-master')}, 2000);
            }
            else if(res.data.flag == '-1'){
                this.handleNotificationClick("tr", 3, "Unable to find promotion/code, API error");
            }
            else{
                this.handleNotificationClick("tr", 3, "Something wrong");
            }

        }).catch(err => {

        })
        this.setState({
            extend_button: false
        })

    }

    sendAddExtraMerchants = () => {


        var data = {
              promotion_id: this.state.campaignID,
              user_id: this.state.user_id,
              merchant_list: this.state.merchantValue,
              chain_list: this.state.chainValue,
              store_list: this.state.storeValue,
              utid: this.state.utidValueExtend
        }

        axios.post(config.get('API_URL') + '/brandemi/submit_merchant_extend_promotion', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            if(res.data.flag == '0'){
                setTimeout(function(){
                    this.componentDidMount()
                }.bind(this), 200);
                this.props.history.push('/admin/admin-promotion-master')
            }
            else if(res.data.flag == '-1'){
                this.handleNotificationClick("tr", 3, "Unable to find promotion/code, API error");
            }
            else{
                this.handleNotificationClick("tr", 3, "Something wrong");
            }

        }).catch(err => {

        })

    }

    sendApproveCampaign = () => {
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("approve this promotion");
            return;
        }
        const timer1 = (Date.now()).toString();
        var data = {
            scheme_id : this.state.campaignID,
            timer1: timer1,
            party_master_id: this.state.party_master_id,
            userID:  this.state.user_id
        }
        axios.post(config.get('API_URL') + '/brandemi/submit_campaign_approve', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {

            setTimeout(function(){
                this.componentDidMount()
            }.bind(this), 200);
            this.props.history.push('/admin/admin-promotion-master')
        }).catch(err => {

        })
        //}
        // else{
        //     this.setState({
        //         campaignConfirmationModel: !this.state.campaignConfirmationModel
        //     }, () =>{
        //         this.handleNotificationClick("tr", 3, "Can't proceed ahead, solve pending issues");
        //     });

        // }

    }

    sendDeactivateCampaign(){
        if(!this.state.canChangePromotionStatus){
            this.showUnauthorizedPopup("deactivate this promotion");
            return;
        }
        let vary = this.state.reason;
        if(vary != null){
            vary = vary.trim();
        }
        if(this.state.reason == null || this.state.reason == '' || vary == '' || vary == null){
            this.handleNotificationClick("tr", 3, "Reason field is mandatory");
        }
        else{

            var data = {
                scheme_id: this.state.campaignID,
                reason: this.state.reason
            }
            axios.post(config.get('API_URL') + '/brandemi/submit_campaign_deactivate', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(res => {
                setTimeout(function(){
                    this.componentDidMount()
                }.bind(this), 200);
                this.props.history.push('/admin/admin-promotion-master')
            }).catch(err => {

            })
        }
    }

    openActivateConfirmation = (status) => {
        if(!this.state.canChangePromotionStatus) {
            this.handleNotificationClick("tr", 3, "You don't have permission to approve this promotion.");
            return;
        }
        this.setState({
            mapFieldCampaign: status,
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    openActivateConfigure = (status) => {
        if(!this.state.canChangePromotionStatus) {
            this.showUnauthorizedPopup("configure this promotion");
            return;
        }
        this.setState({
            mapFieldConfigure: status,
            campaignConfigureModel: !this.state.campaignConfigureModel
        });
    }

    openExtendPromotion = (status) => {
            if(!this.state.canChangePromotionStatus) { 
                this.showUnauthorizedPopup("extend this promotion");
                return;
            }
        this.setState({
            mapFieldExtend: status,
            campaignExtendModel: !this.state.campaignExtendModel
        });
    }

    openAddMerchants = (status) => {
        this.setState({
            mapFieldExtendMerchants: status,
            campaignExtendMerchantsModel: !this.state.campaignExtendMerchantsModel
        });
    }

    openQAConfigure = (status) => {
        if(!this.state.canChangePromotionStatus) {
            this.handleNotificationClick("tr", 3, "You don't have permission to change this promotion status.");
            return;
        }
        this.setState({
            mapFieldQA: status,
            campaignQAModel: !this.state.campaignQAModel
        });
    }

    openFinalConfigure = (status) => {
        if(!this.state.canChangePromotionStatus) {
            this.handleNotificationClick("tr", 3, "You don't have permission to change this promotion status.");
        return;
        }
        this.setState({
            mapFieldFinal: status,
            campaignFinalModel: !this.state.campaignFinalModel
        });
    }

    openDeactivateConfirmation = (status) => {
        if(!this.state.canChangePromotionStatus) {
         
            this.handleNotificationClick("tr", 3, "You don't have permission to deactivate this promotion.");
        return;
        }
        this.setState({
            mapFieldCampaign: status,
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    tabClicker(value){
        if(value == 1){
            this.setState({
                stepper: {...this.state.stepper, [1]: true},
                stepper: {...this.state.stepper, [2]: true},
                stepper: {...this.state.stepper, [3]: true}
            })
        }
    }

    // onChangeHandler = event => {
    //     if (event.target.files.length == 0){
    //         this.handleNotificationClick("tr", 3, "Please select a file");
    //     }
    //     else{
    //         var file = event.target.files[0];
    //         var ext = this.getFileExtension(file.name);
    //         if (ext === 'csv') {
    //             this.setState({
    //                 selectedFile: file,
    //                 file_name: file.name
    //             });
    //         } else {
    //             this.handleNotificationClick("tr", 3, "Please upload valid file");
    //             this.setState({
    //                 selectedFile: file
    //             });
    //         }
    //     }

    // };

    maxSelectFile=(event)=>{
        let files = event.target.files // create file object
        if (files.length > 10) {
            const msg = 'Only 10 files can be uploaded at a time'
            event.target.value = null // discard selected file
            //console.log(msg)
            return false;

        }
        else if (files.length == 0) {
            const msg = 'Upload atleast 1 file';
            event.target.value = null // discard selected file
            //console.log(msg)
            return false;

        }
        return true;
    }

    onChangeHandler=event=>{
        var files = event.target.files
        if(this.maxSelectFile(event) && this.checkMimeType(event)){
            // if return true allow to setState
            this.setState({
                selectedFile: files,
                upload_it: true
            })
        }
        else{
            this.setState({
                upload_it: false
            })
        }
    }


    checkMimeType=(event)=>{
        //getting file object
        let files = event.target.files
        //define message container
        let err = ''
        // list allow mime type
        const types = ['image/png', 'image/jpeg', 'text/plain', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf', 'message/rfc822']
        // loop access array
        for(var x = 0; x<files.length; x++) {
            //console.log(files[x]);
            if (types.every(type => files[x].type !== type)) {
                // create error message and assign to container
                err += files[x].type+' is not a supported format\n';
            }
        };

        if (err !== '') { // if message not same old that mean has error
            event.target.value = null // discard selected file
            //console.log(err)
            this.handleNotificationClick("tr", 3, "Upload only valid file formats");
            return false;
        }
        return true;

    }

    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        ////console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // //console.log(decoded);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        //console.log(decoded.userGroup);
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile; ////console.log(data);
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/promotion_file_upload", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                    .then(res => {
                        //console.log(res.data);
                        this.setState({
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name
                        });
                        ////console.log(res.data.notify);
                        ////console.log(res.data.inconsistent);
                        if (res.data.flag == -1){
                            this.handleNotificationClick("tr", 3, "Something Wrong");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: '',
                                error_message_header: 'Something Wrong',
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.flag == 2){
                            this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: '',
                                error_message_header: 'Duplicate File',
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Failure'
                            });
                        }
                        else if(res.data.flag == 3){
                            this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: res.data.total_value + '/' + res.data.total,
                                error_message_header: 'Failure'
                            });

                        }
                        else if(res.data.flag == 4){
                            this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: res.data.total_value + '/' + res.data.total,
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.flag == 5){
                            this.handleNotificationClick("tr", 3, "File is not in csv utf-8 format.");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: '',
                                error_message_header: 'Duplicate File',
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.flag == 6){
                            this.handleNotificationClick("tr", 3, "No data present in uploaded csv");
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: '',
                                error_message_header: 'Empty Template',
                                error_message: '0' + '/' + '0',
                                error_message_header: 'Failure'
                            });
                        }
                        else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
                            this.setState({
                                isSubmit: false,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name,
                                error_message: res.data.total_value + '/' + res.data.total
                            });
                            //console.log("call show method on success");
                            this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                            this.toggleNoErrorModel.bind(this);
                            this.setState({
                                error_message_header: 'Success'
                            })
                            this.getBrandUploadedData();
                        }

                        else {
                            if (res.data.error2 === 1){
                                this.setState({
                                    error_message_header: 'Failure'
                                })
                            }
                            else{
                                this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                                this.toggleNoErrorModel.bind(this);
                                this.setState({
                                    error_message_header: 'Success'
                                })
                            }
                            this.setState({
                                isSubmit: false,
                                error_message: res.data.total_value + '/' + res.data.total,
                                loading: false,
                                notify: res.data.notify,
                                file_id_got: res.data.file_id,
                                report_file_name: res.data.report_file_name,
                                report_download_name: res.data.report_download_name
                            });
                            this.getBrandUploadedData();
                        }
                    })
                    .catch(err => {
                        //console.log(err);// then print response status
                        this.handleNotificationClick("tr", 3, "Something Wrong!");
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                        // this.openSectionToMap(true); // remove and place in success block
                    })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    downloadCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_promotion_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= null;
                //console.log(file_value);
                //console.log(xhr.getResponseHeader('Content-Disposition'));
                if(file_id == '7xhmd38Hhdad3_brand_product_master_template.csv'){
                    fileName = 'products-template.csv';
                }
                else{
                    fileName= file_value;
                }
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // //console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };


    getProducts = () => {
        this.setState({
            loading: true
        })
        var postData = {
            party_master_id: this.state.party_master_id,
            promotion_id: this.props.match.params.id
        };

        let xhr = $.ajax({
            url:config.get('API_URL')+ "/brandemi/download_promotion_product_details",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = this.state.campaign_name + "_product_details.csv.gz";
                let rfile = fileName.replace(/\"/g, "");
                ////console.log(fileName)
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr,
            loading: false
        })
    }
    convertToCSV = (data) => {
    const array = Array.isArray(data) ? data : [data];
    const headers = Object.keys(array[0]).join(",");
    const rows = array.map(row => Object.values(row).join(","));
    return [headers, ...rows].join("\n");
  };
    downloadSchemeCSV = () => {
    const csv = this.convertToCSV(this.state.scheme_master_data_export);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "scheme.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
    downloadProductCSV = () => {
    const csv = this.convertToCSV(this.state.raw_display_data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "product.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

    getSchemes = () => {
        this.setState({
            loading: true
        })
        var postData = {
            party_master_id: this.state.party_master_id,
            promotion_id: this.props.match.params.id
        };

        let xhr = $.ajax({
            url:config.get('API_URL')+ "/brandemi/download_promotion_scheme_details",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = this.state.campaign_name + "_scheme_details.csv";
                let rfile = fileName.replace(/\"/g, "");
                ////console.log(fileName)
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr,
            loading: false
        })
    }



    getMerchants = () => {
        this.setState({
            loading: true
        })
        var postData = {
            party_master_id: this.state.party_master_id,
            promotion_id: this.props.match.params.id
        };

        let xhr = $.ajax({
            url:config.get('API_URL')+ "/brandemi/download_promotion_merchant_details",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = this.state.campaign_name + "_merchant_details.csv";
                let rfile = fileName.replace(/\"/g, "");
                ////console.log(fileName)
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr,
            loading: false
        })
    }

    render() {
        //console.log(this.state.user_id);
        //console.log(this.state.utidList);
        //console.log(new Date());
        const { canChangePromotionStatus } = this.state;
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };


        // let merchant_displayer = () => {
        //     if(decoded.userGroup == 2 || decoded.userGroup == '2'){
        //         return(<div></div>)
        //     }
        //     else{
        //         return(
        //             <div className="row">
        //                 <div className="col-md-4">
        //                     <Label>Select Merchant:</Label>
        //                     <ReactMultiSelectCheckboxes name={"merchant_selector"}
        //                                                 components={{ MenuList }}
        //                                                 isClearable={false}
        //                                                 onChange={this.changeMerchant1.bind(this)}
        //                                                 styles={customStyles} className="report-listbox"
        //                                                 options={this.state.merchantList}
        //                                                 value={this.state.merchantValue}
        //                                                 isMulti
        //                                                 placeholderButtonLabel="All"
        //                     />
        //                 </div>
        //                 <div className="col-md-4">
        //                     <Label>Select Chain:</Label>
        //                     <ReactMultiSelectCheckboxes name={"chain_selector"}
        //                                                 components={{ MenuList }}
        //                                                 isClearable={false}
        //                                                 onChange={this.changeChain.bind(this)}
        //                                                 styles={customStyles} className="report-listbox"
        //                                                 options={this.state.chainList}
        //                                                 value={this.state.chainValue}
        //                                                 isMulti
        //                                                 placeholderButtonLabel="All"
        //                     />
        //                 </div>
        //                 <div className="col-md-4">
        //                     <Label>Select Store:</Label>
        //                     <ReactMultiSelectCheckboxes name={"store_selector"}
        //                                                 components={{ MenuList }}
        //                                                 isClearable={false}
        //                                                 onChange={this.changeStore.bind(this)}
        //                                                 styles={customStyles} className="report-listbox"
        //                                                 options={this.state.storeList}
        //                                                 value={this.state.storeValue}
        //                                                 isMulti
        //                                                 placeholderButtonLabel="All"
        //                     />
        //                 </div>
        //             </div>
        //         )
        //     }
        // }

        let merchant_table_displayer = this.state.merchant_master_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                    <td>{value.merchant_name}</td>
                    <td>{value.merchant_code}</td>
                    <td>{value.chain_name}</td>
                    <td>{value.chain_code}</td>
                    <td>{value.store_name}</td>
                    <td>{value.store_code}</td>
                </tr>
            )
        });

        let scheme_sku_mapper_table_displayer = this.state.scheme_sku_mapper_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                    <td>{value.issuerSchemeDisplayName}</td>
                    <td>{value.brandSku}</td>
                    <td>{value.brandDescription}</td>
                </tr>
            )
        });

        let extender = () => {
            if(((this.state.scheme_active == '4' || this.state.scheme_active == 4) || (this.state.scheme_active == '6' || this.state.scheme_active == 6)) && (this.state.promotion_flag == 1 || this.state.promotion_flag == '1')){
                return(
                    <div className="col-sm-6 col-md-3 col-xs-12">
                        <Label> Extend Promotion </Label>
                        <button onClick={this.openExtendPromotion.bind(this)} className="btn btn-primary">Extend Promotion</button>
                    </div>
                )
            }
            else{
                return(<div></div>)
            }
        }

        let merchant_extender = () => {
            if((this.state.scheme_active == '4' || this.state.scheme_active == 4) && (this.state.promotion_flag == 1 || this.state.promotion_flag == '1')){
                return(
                    <div>
                        <Button onClick={this.openAddMerchants.bind(this)} className="btn btn-primary btn-capitalize pull-right">Add Additional Merchants</Button>
                    </div>
                )
            }
            else{
                return(<div></div>)
            }
        }

        let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
            let timer2 = new Date(value.recordUpdateTimestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            // let cashback_render = '';
            // let brand_sub_render = value.brand_sub;
            // let brand_sub_amount_render = value.brand_sub_amount;
            // let post_brand_sub_render = value.post_brand_sub;
            // let post_brand_sub_amount_render = value.post_brand_sub_amount;
            // let tenure_render = value.tenure;
            // let scheme_type = 'Brand EMI';
            // let emi_typea = 'Non EMI';
            // if (value.is_emi == 0 || value.is_emi == '0'){
            //     tenure_render = 'NA';
            // }
            // else if(value.is_emi == 1 || value.is_emi == '1'){
            //     emi_typea = 'Zero Cost'
            // }
            // else if(value.is_emi == 2 || value.is_emi == '2'){
            //     emi_typea = 'Low Cost'
            // }
            // if (value.is_cashback == 0 || value.is_cashback == '0'){
            //     cashback_render = 'No';
            //     brand_sub_render = 'NA';
            //     brand_sub_amount_render = 'NA';
            //     // post_cashback_render = 'No';
            //     post_brand_sub_render = 'NA';
            //     post_brand_sub_amount_render = 'NA';
            // }
            // else{
            //     cashback_render = 'Yes';
            //     // post_cashback_render = 'Yes';
            // }
            // if(value.scheme_type == 'exclusiveemi'){
            //     scheme_type = 'Exclusive EMI';
            // }
            // else if(value.scheme_type == 'freeemi'){
            //     scheme_type = 'Free EMI';
            // }
            // let max_cashback_render = value.max_cashback.slice(0, -1);
            // //if(max_cashback_render == -1 || max_cashback_render == '-1'){
            // if(max_cashback_render == '0.00'){
            //     max_cashback_render = 'NA';
            // }
            // let post_max_cashback_render = value.post_max_cashback.slice(0, -1);
            // //if(max_cashback_render == -1 || max_cashback_render == '-1'){
            // if(post_max_cashback_render == '0.00'){
            //     post_max_cashback_render = 'NA';
            // }
            return (
                <tr key={index + 1}>
                    <td>{value.schemeName}</td>
                    <td>{value.bankName}</td>
                    <td>{value.schemeType}</td>
                    <td>{value.emiType}</td>
                    <td>{value.tenure}</td>
                    <td>{value.availCashback}</td>
                    <td>{value.upfrontCashbackBrand}</td>
                    <td>{value.upfrontCashbackBank}</td>
                    <td>{value.postCashbackBrand}</td>
                    <td>{value.postCashbackBank}</td>
                    <td>{value.lowCostSubvention}</td>
                    <td>{value.upfrontBrandSub}</td>
                    <td>{value.upfrontBrandSubAmount}</td>
                    <td>{value.upfrontMaxCashback}</td>
                    <td>{value.postBrandSub}</td>
                    <td>{value.postBrandSubAmount}</td>
                    <td>{value.postBrandMaxAmount}</td>
                    <td>{value.bankCbPer}</td>
                    <td>{value.bankMaxCb}</td>
                    <td>{timer3}</td>
                    <td>{'Yes'}</td>
                </tr>
            )
        });

        // let merchant_data_master = null;
        // if(this.state.party_master_id != null && this.state.merchant2_display_data.length != 0){
        //     merchant_data_master = this.state.merchant2_display_data.map((value, index) =>{
        //         return (
        //             <tr key={index + 1}>
        //             <td>{value.merchant_id}</td>
        //             <td>{value.merchant_name}</td>
        //             <td>{value.merchant_code}</td>
        //             <td>{value.chain_id}</td>
        //             <td>{value.chain_name}</td>
        //             <td>{value.chain_code}</td>
        //             <td>{value.store_id}</td>
        //             <td>{value.store_name}</td>
        //             <td>{value.store_code}</td>
        //             <td>{value.store_address}</td>
        //             <td>{value.field_1}</td>
        //             <td>{(this.state.merchant_master_list[value.id]) ? 'Yes' : 'No'}</td>
        //         </tr>
        //         )
        //     });
        // }

        ////console.log(this.state.raw_display_data)
        ////console.log(this.state.endDate);

        //const { redirect } = this.state;
        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate); //.toDateString();
        let start_date_frmt = new Date(this.state.startDate);

        let end_date = new Date(this.state.endDate);

        let end_date_extender = new Date(this.state.endDateExtend);
        let end_date_extend = end_date_extender;

        //end_date.setDate( end_date.getDate() - 1 ); //.toDateString();
        let end_date2 = end_date.setDate( end_date.getDate() - 1 );



        // let min_date = end_date.setDate( end_date.getDate() + 1);
        // min_date = moment(min_date).format('YYYY-MM-DD');


        let dayBeforeYesterday = new Date( new Date().setDate(new Date().getDate() - 1) );
        let new_min_date = dayBeforeYesterday > start_date_frmt ? dayBeforeYesterday : start_date_frmt ;
        // let new_min_date = new Date() > start_date_frmt ? new Date() : start_date_frmt ;
        new_min_date = moment(new_min_date).format('YYYY-MM-DD');



        end_date2 = moment(end_date2).format('YYYY-MM-DD');
        let end_date3 = end_date.setDate(end_date.getDate());
        let max_txn = this.state.maxTxnAmount;

        let sku_show_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                    <td>{value.manufacturerDisplayName}</td>
                    <td>{value.categoryDisplayName}</td>
                    <td>{value.modelDisplayNumber}</td>
                    <td>{value.modelVersion}</td>
                    <td>{value.modelDisplayNumber}</td>
                    <td>{value.brandSku}</td>
                    <td>{value.productMaxSellingPrice}</td>
                    <td>{value.productMinSellingPrice}</td>
                    <td>{'Yes'}</td>
                </tr>
            );
        });

        // let promotion_show_data = this.state.promotion_file_display_data.map((value,index) => {
        //     return (
        //         <tr key={index + 1}>
        //             <td>{index + 1}</td>
        //             <td>{value.file_name}</td>
        //             <td>
        //                 <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
        //                 <Link className="viewButton" data-tip="Download File" onClick={this.downloadCSV.bind(this, value.id, value.file_name)}><span className="glyphicon glyphicon-download-alt" aria-hidden="true"></span></Link>
        //             </td>
        //         </tr>
        //     );
        // });

        let variabler = this.state.current_tab;
        let active_finder = '';
        let active_button_enabler = () =>{
            if (this.state.scheme_active == 0 || this.state.scheme_active == '0'){
                return (
                    <div className="row top-pad-10">
                        <div className="col-md-12">
                            <Button onClick={this.openDeactivateConfirmation.bind(this, true)} className="btn-capitalize2 pull-right">Reject Promotion</Button>
                            <Button onClick={this.openActivateConfirmation.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">Approve Promotion</Button>{' '}
                        </div>
                    </div>
                );
                return(
                    <div></div>
                )
            }
            else if(this.state.scheme_active == 1 || this.state.scheme_active == '1'){
                return (
                    <div className="row top-pad-10">
                        <div className="col-md-12">
                            <Button onClick={this.openDeactivateConfirmation.bind(this, true)} className="btn-capitalize2 pull-right">Reject Promotion</Button>
                            <Button onClick={this.openActivateConfigure.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">Configure Promotion</Button>{' '}
                        </div>
                    </div>
                );
            }
            else if(this.state.scheme_active == 2 || this.state.scheme_active == '2'){
                return (
                    <div className="row top-pad-10">
                        <div className="col-md-12">
                            <Button onClick={this.openDeactivateConfirmation.bind(this, true)} className="btn-capitalize2 pull-right">Reject Promotion</Button>
                            <Button onClick={this.openQAConfigure.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">QA Verify</Button>{' '}
                        </div>
                    </div>
                );
            }
            else if(this.state.scheme_active == 3 || this.state.scheme_active == '3'){
                return (
                    <div className="row top-pad-10">
                        <div className="col-md-12">
                            <Button onClick={this.openDeactivateConfirmation.bind(this, true)} className="btn-capitalize2 pull-right">Reject Promotion</Button>
                            <Button onClick={this.openFinalConfigure.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">Activate Promotion</Button>{' '}
                        </div>
                    </div>
                );
            }
            else{
                return(<div></div>)
            }
        }
        if (this.state.scheme_active == 1 || this.state.scheme_active == '1'){
            active_finder = ' - Approved';
        }
        else if(this.state.scheme_active == 0 || this.state.scheme_active == '0'){
            active_finder = ' - Created';
        }
        else if(this.state.scheme_active == 2 || this.state.scheme_active == '2'){
            active_finder = ' - Configured';
        }
        else if(this.state.scheme_active == 3 || this.state.scheme_active == '3'){
            active_finder = ' - QA verified';
        }
        else if(this.state.scheme_active == 4 || this.state.scheme_active == '4'){
            active_finder = ' - Active';
        }
        else if(this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
            active_finder = ' - Rejected';
        }
        else{
            active_finder = ' - Expired';
        }
        let campaign_header = this.state.campaign_name + active_finder;

        // let to_show_table = () => {
        //     if(this.state.scheme_active == 1 || this.state.scheme_active == '1' || this.state.scheme_active == 2 || this.state.scheme_active == '2' || this.state.scheme_active == 3 || this.state.scheme_active == '3' || this.state.scheme_active == 4 || this.state.scheme_active == '4'){
        //         return(
        //             <div>
        //             <div className = "row top-margin-30">
        //                 <div className="header header-promotion">
        //                     <h4 className="title">Files</h4>

        //                 </div>
        //             </div>
        //             <div className="table-full-width table-responsive">
        //         <div className="row m-0">
        //             <div className="col-md-12">
        //                 <table className="table table-striped table-hover" id="sku_showTable">
        //                     <thead>
        //                         <tr>
        //                             <th>Sr No.</th>
        //                             <th>File Name</th>
        //                             <th>Action</th>
        //                         </tr>
        //                     </thead>
        //                     <tbody>
        //                         {promotion_show_data}
        //                     </tbody>
        //                 </table>
        //             </div>
        //             <div className="col-md-12">
        //                 {/* <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary">Choose Offers</button> */}
        //             </div>
        //             </div>
        //         </div>
        //         </div>
        //         )
        //     }
        //     else{
        //         return(<div></div>)
        //     }

        // }

        let reason_giver = () => {
            if (this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
                return(
                    <div className="row bottompaddingsubvention">
                        <div className=" col-sm-6 col-md-3 col-xs-12">
                            <Label>Rejection Reason</Label>
                            <Input id="reason" className="maxheighter" value={this.state.reason} disabled={true}/>
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }

        return(
            <div className="content">
                <CommonNavbar/>
                <div className="container-fluid">
                    <NotificationSystem ref="notificationSystem" style={style} />
                    <ReactTooltip />
                    <div className="row">
                        <div className="col-md-12 top-pad-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">{campaign_header}
                                    </h4>
                                </div>
                                <div className="content">
                                    {/* defaultTab="vertical-tab-two" */}
                                    <Tabs defaultTab={variabler} vertical className="vertical-tabs">
                                        <TabList>
                                            <Tab className="tab-title" tabFor="vertical-tab-one" onClick={this.tabClicker.bind(this, 1)}>
                                                <h4 className='title'>Products(SKUs)</h4>
                                                <span className='text-muted'>
                                                    Selected products
                                                </span>

                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-two" onClick={this.tabClicker.bind(this, 2)}>
                                                <h4 className='title'> Schemes</h4>
                                                <span className='text-muted'>
                                                    Selected schemes
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-three" onClick={this.tabClicker.bind(this, 3)}>
                                                <h4 className='title'>Map schemes</h4>
                                                <span className='text-muted'>
                                                    Map schemes
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-four" onClick={this.tabClicker.bind(this, 4)}>
                                                <h4 className='title'>  Merchants</h4>
                                                <span className='text-muted'>
                                                    Selected merchants
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-five" onClick={this.tabClicker.bind(this, 5)}>
                                                <h4 className='title'>  Details</h4>
                                                <span className='text-muted'>
                                                    Configured details
                                                </span>
                                            </Tab>
                                        </TabList>
                                        <TabPanel tabId="vertical-tab-one">
                                            {/* <Collapse isOpen={this.state.mapField0}> */}
                                            <div className="card-query-builder" >
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <Button onClick={this.downloadProductCSV} className="btn btn-primary btn-capitalize pull-right">Export Product Details</Button>
                                                            <h4 className="title">Products(SKUs)</h4>
                                                            <span className='text-muted'>Selected products/SKUs are part of this promotion</span>
                                                        </div>
                                                        <Modal className="modalsmall" isOpen={this.state.campaignConfigureModel}
                                                               toggle={this.toggleConfigureModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4"> Are you sure you want to configure?</h4>
                                                                    </div>
                                                                </div>
                                                                <ModalFooter>
                                                                    <Button color="primary"  className="btn btn-primary btn-capitalize" onClick={this.sendConfigureCampaign}>Configure Promotion</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleConfigureModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>

                                                        <Modal className="modalsmall" isOpen={this.state.campaignQAModel}
                                                               toggle={this.toggleQAModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4"> Are you sure you want to QA verify?</h4>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-xs-12 col-md-4">
                                                                        <Label>Select Utids:</Label>
                                                                        <ReactMultiSelectCheckboxes name={"utid_selector"}
                                                                                                    components={{ MenuList }}
                                                                                                    isClearable={false}
                                                                                                    onChange={this.changeUtid.bind(this)}
                                                                                                    styles={customStyles} className="report-listbox"
                                                                                                    options={this.state.utidList}
                                                                                                    value={this.state.utidValue}
                                                                                                    isMulti
                                                                                                    placeholderButtonLabel="All"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <ModalFooter>
                                                                    <Button color="primary"  className="btn btn-primary btn-capitalize" onClick={this.sendQAVerifiedCampaign}>QA Verify</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleQAModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>

                                                        <Modal className="modalsmall" isOpen={this.state.campaignExtendModel}
                                                               toggle={this.toggleExtendModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                  <div className="col-xs-12 ">
                                                                     <h4 className="modalh4">Are you sure you want to extend promotion?</h4>
                                                                   </div>
                                                                 </div>
                                                                <div className="row">
                                                                    <div className="col-xs-12 col-md-4">
                                                                        <Label>New start date:</Label>
                                                                        <DatePicker
                                                                            dateFormat="dd-MM-yyyy"
                                                                            selected={this.state.startDateExtend ? new Date(this.state.startDateExtend) : null}
                                                                            onChange={this.handleExtendStartDateChange}
                                                                            minDate={new Date()} 
                                                                        />
                                                                    </div>
                                                                    <div className="col-xs-12 col-md-4">
                                                                        <Label>New end date:</Label>
                                                                        <DatePicker
                                                                            dateFormat="dd-MM-yyyy"
                                                                            selected={new Date(end_date_extend)}
                                                                            onChange={this.handleExtendChange}
                                                                            minDate={new Date(new_min_date)}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <ModalFooter>
                                                                    <Button color="primary" disabled={this.state.extend_button} className="btn btn-primary btn-capitalize" onClick={this.sendExtendPromotion}>Extend Promotion</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleExtendModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>

                                                        <Modal isOpen={this.state.campaignExtendMerchantsModel}
                                                               toggle={this.toggleExtendMerchantModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4"> Are you sure you want to add more merchants?</h4>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <Label>Select Merchant:</Label>
                                                                        <ReactMultiSelectCheckboxes name={"merchant_selector"}
                                                                                                    components={{ MenuList }}
                                                                                                    isClearable={false}
                                                                                                    onChange={this.changeMerchant1.bind(this)}
                                                                                                    styles={customStyles} className="report-listbox"
                                                                                                    options={this.state.merchantList}
                                                                                                    value={this.state.merchantValue}
                                                                                                    isMulti
                                                                                                    placeholderButtonLabel="All"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <Label>Select Chain:</Label>
                                                                        <ReactMultiSelectCheckboxes name={"chain_selector"}
                                                                                                    components={{ MenuList }}
                                                                                                    isClearable={false}
                                                                                                    onChange={this.changeChain.bind(this)}
                                                                                                    styles={customStyles} className="report-listbox"
                                                                                                    options={this.state.chainList}
                                                                                                    value={this.state.chainValue}
                                                                                                    isMulti
                                                                                                    placeholderButtonLabel="All"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <Label>Select Store:</Label>
                                                                        <ReactMultiSelectCheckboxes name={"store_selector"}
                                                                                                    components={{ MenuList }}
                                                                                                    isClearable={false}
                                                                                                    onChange={this.changeStore.bind(this)}
                                                                                                    styles={customStyles} className="report-listbox"
                                                                                                    options={this.state.storeList}
                                                                                                    value={this.state.storeValue}
                                                                                                    isMulti
                                                                                                    placeholderButtonLabel="All"
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <Label>Select Utids:</Label>
                                                                        <ReactMultiSelectCheckboxes name={"utid_selector_extend"}
                                                                                                    components={{ MenuList }}
                                                                                                    isClearable={false}
                                                                                                    onChange={this.changeUtidExtend.bind(this)}
                                                                                                    styles={customStyles} className="report-listbox"
                                                                                                    options={this.state.utidListExtend}
                                                                                                    value={this.state.utidValueExtend}
                                                                                                    isMulti
                                                                                                    placeholderButtonLabel="All"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <ModalFooter>
                                                                    <Button color="primary" className="btn btn-primary btn-capitalize" onClick={this.sendAddExtraMerchants}>Extend Merchants</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleExtendMerchantModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>

                                                        <Modal className="modalsmall" isOpen={this.state.campaignFinalModel}
                                                               toggle={this.toggleFinalModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4"> Are you sure you want to activate?</h4>
                                                                    </div>
                                                                </div>
                                                                {/*<div className="row">*/}
                                                                {/*    <div className="col-xs-12 col-md-6">*/}
                                                                {/*        <Label>Automation Type:</Label>*/}
                                                                {/*        <Select name={"automation_type"}*/}
                                                                {/*                defaultValue={this.state.automation_type_value}*/}
                                                                {/*                onChange={this.changeAutomationType.bind(this)}*/}
                                                                {/*                options={[{value: 'new', label:'New Automation'}, {value: 'old', label:'Old Automation'}]}*/}
                                                                {/*                placeholder="Select automation type"*/}
                                                                {/*            // isDisabled={!is_emi_render}*/}
                                                                {/*            // isClearable={true}*/}
                                                                {/*        />*/}
                                                                {/*    </div>*/}
                                                                {/*    <div className="col-xs-12 col-md-6">*/}
                                                                {/*        <Label>Instance Type:</Label>*/}
                                                                {/*        <Select name={"instance_type"}*/}
                                                                {/*                defaultValue={this.state.ip_instance_data[0]}*/}
                                                                {/*                onChange={this.changeInstanceType.bind(this)}*/}
                                                                {/*                options={this.state.ip_instance_data}*/}
                                                                {/*                placeholder="Select instance type"*/}
                                                                {/*            // isDisabled={!is_emi_render}*/}
                                                                {/*            // isClearable={true}*/}
                                                                {/*        />*/}
                                                                {/*    </div>*/}
                                                                {/*</div>*/}

                                                                <ModalFooter>
                                                                    <Button color="primary"  className="btn btn-primary btn-capitalize" onClick={this.sendFinalCampaign}>Activate Promotion</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleFinalModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>

                                                        <Modal className="modalsmall" isOpen={this.state.campaignConfirmationModel}
                                                               toggle={this.toggleCampaignModel.bind(this)}
                                                               size = "sm"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4"> Are you sure you want to approve?</h4>
                                                                    </div>
                                                                </div>
                                                                <ModalFooter>
                                                                    <Button color="primary"  className="btn btn-primary btn-capitalize" onClick={this.sendApproveCampaign}>Approve Promotion</Button>{' '}
                                                                    <Button color="secondary" className="btn btn-primary btn-capitalize2" onClick={this.toggleCampaignModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>
                                                        <Modal className="modalsmall" isOpen={this.state.campaignDeconfirmationModel}
                                                               toggle={this.toggleDecampaignModel.bind(this)}
                                                               size = "lg"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4">Are you sure you want to reject this promotion?</h4>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 ">
                                                                        <Label>Enter Reason (mandatory):</Label>
                                                                        <Input id="reason" className="maxheighter" value={this.state.reason} onChange={(e)=> {
                                                                            let {reason} = this.state;
                                                                            reason = e.target.value;
                                                                            if(reason != null){
                                                                                reason = reason.trim();
                                                                            }
                                                                            if((reason == '' || reason == null)){
                                                                                this.handleNotificationClick("tr", 3, "Insert valid reason");
                                                                            }
                                                                            this.setState({
                                                                                reason: reason
                                                                            })
                                                                        }}/>
                                                                    </div>
                                                                </div>
                                                                <ModalFooter>
                                                                    <Button color="primary" className="btn btn-primary btn-capitalize" onClick={this.sendDeactivateCampaign.bind(this)}>Reject Promotion</Button>{' '}
                                                                    <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button>
                                                                </ModalFooter>
                                                            </ModalBody>
                                                        </Modal>
                                                        <div className='sweet-loading'>
                                                            <BeatLoader
                                                                css={override}
                                                                sizeUnit={"px"}
                                                                size={20}
                                                                color={'#123abc'}
                                                                loading={this.state.loading}
                                                            />
                                                        </div>
                                                        <div className="table-full-width table-responsive">
                                                            <div className="row m-0">
                                                                <div className="col-md-12">
                                                                    <table className="table table-striped table-hover" id="sku_showTable">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Brand</th>
                                                                            <th>Category</th>
                                                                            <th>Model Name</th>
                                                                            <th>Model Number</th>
                                                                            <th>Model Description</th>
                                                                            <th>SKU</th>
                                                                            <th>MRP</th>
                                                                            <th>MOP</th>
                                                                            <th>Selected?</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {sku_show_data}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    {/* <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary">Choose Offers</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </Collapse> */}
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-two">
                                            <div className="card-query-builder">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <Button onClick={this.downloadSchemeCSV} className="btn btn-primary btn-capitalize pull-right">Export Scheme Details</Button>
                                                            <h4 className="title">Schemes</h4>
                                                            <span className="text-muted">Selected schemes are part of this promotion</span>
                                                        </div>

                                                        <div className="table-full-width table-responsive">
                                                            <table className="table table-striped table-hover" id="brandSchemeMasterViewTable">
                                                                <thead>
                                                                <tr>
                                                                    <th>Scheme Name</th>
                                                                    <th>Bank Name</th>
                                                                    <th>Scheme Type</th>
                                                                    <th>EMI Type</th>
                                                                    <th>Tenure</th>
                                                                    <th>Avail Cashback?</th>
                                                                    <th>Upfront Cashback Brand</th>
                                                                    <th>Upfront Cashback Bank</th>
                                                                    <th>Post Cashback Brand</th>
                                                                    <th>Post Cashback Bank</th>
                                                                    <th>Low Cost Subvension</th>
                                                                    <th>Upfront Brand Sub</th>
                                                                    <th>Upfront Brand Sub Amount</th>
                                                                    <th>Upfront Max Cash back</th>
                                                                    <th>Post Brand Sub</th>
                                                                    <th>Post Brand Sub Amount</th>
                                                                    <th>Post Max Cash back</th>
                                                                    <th>Bank CB Per</th>
                                                                    <th>Bank Max CB</th>
                                                                    <th>Time stamp</th>
                                                                    <th>Selected?</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {scheme_data_master}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="row">
                                                            {/* <div className ="col-md-12">
                                                                <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Choose Schemes</button>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-three">
                                            <div className="col-md-12">

                                                <div className="card noshadow">

                                                    <div className="row">

                                                        <div className="col-md-12">
                                                            <div className="header header-promotion">
                                                                <h4 className="title">Map Schemes</h4>
                                                                <span className="text-muted">Following is the scheme-sku mapping table</span>
                                                            </div>
                                                            <div className="table-full-width table-responsive">
                                                                <table className="table table-striped table-hover" id="schemeSKUMapperViewTable">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>Scheme Name</th>
                                                                        <th>SKU</th>
                                                                        <th>Model Description</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {scheme_sku_mapper_table_displayer}
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="footer">
                                                        <div className="stats"><i></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-four">
                                            <div className="col-md-12">

                                                <div className="card noshadow">

                                                    <div className="row">

                                                        <div className="col-md-12">
                                                            <div className="header header-promotion">
                                                                {merchant_extender()}

                                                                <Button onClick={this.getMerchants} className="btn btn-primary btn-capitalize pull-right">Export Merchant Details</Button>
                                                                <h4 className="title">Merchants</h4>
                                                                <span className="text-muted">Selected merchants are now part of this promotion</span>
                                                            </div>
                                                            <div className="table-full-width table-responsive">
                                                                <table className="table table-striped table-hover" id="brandMerchantMasterViewTable">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>Merchant Name</th>
                                                                        <th>Merchant Code</th>
                                                                        <th>Chain Name</th>
                                                                        <th>Chain Code</th>
                                                                        <th>Store Name</th>
                                                                        <th>Store Code</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {merchant_table_displayer}
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="footer">
                                                        <div className="stats"><i></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-five">
                                            <div className="card-query-builder subvention-brand longcontent ">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Promotion Details</h4>
                                                            <span className="text-muted">The following are the promotion details</span>
                                                        </div>

                                                        <div className= "content">
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Promotion Name</Label>
                                                                    <Input id="campaign_name" className="maxheighter" value={this.state.campaign_name} disabled={true}/>
                                                                </div>
                                                                <div className=" col-sm-12 col-md-6 col-xs-12">
                                                                    <Label>Promotion Description</Label>
                                                                    <Input id="campaign_desc" className="maxheighter" value={this.state.campaign_desc} disabled={true}/>
                                                                </div>
                                                            </div>

                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select start date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.startDate)}
                                                                        onChange={this.handleFromChange}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select end date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(end_date2)}
                                                                        onChange={this.handleToChange}
                                                                        disabled={true}
                                                                    />
                                                                </div>


                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>EMI Type Selection</Label>
                                                                    <Select name={"emi_type"}
                                                                            value={this.state.selceted_emi_type_value_label}
                                                                        // onChange={this.updateEmiTypeValue.bind(this)}
                                                                            options={this.state.selected_emi_type_option}
                                                                            placeholder="Select"
                                                                            isDisabled={true}
                                                                    />
                                                                </div>


                                                                {extender()}
                                                                {/* <div className="col-sm-6 col-md-4    col-xs-12">
                                                                <Label>Maximum cashback allowed per card</Label>
                                                                <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                                                    let {maxTxnAmount1} = this.state;
                                                                    maxTxnAmount1 = e.target.value;
                                                                    if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                                        this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                                                    }
                                                                    this.setState({
                                                                        maxTxnAmount: maxTxnAmount1,
                                                                        mapField2: false
                                                                    })
                                                                }}/>
                                                                </div> */}
                                                            </div>

                                                            {/* {to_show_table()} */}
                                                            {reason_giver()}
                                                            {/* <button onClick={this.openSectionToProduct.bind(this, true)} className="btn btn-primary">Save</button> */}
                                                            {active_button_enabler()}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default AdminViewPromotion;